// src/components/store/sections/gallery/GalleryV29PolaroidwallFuchsiaGlow.tsx
"use client";

import React from "react";
import DynamicGalleryVariant from "./DynamicGalleryVariant";

export default function GalleryV29PolaroidwallFuchsiaGlow(props: any) {
  return (
    <DynamicGalleryVariant
      variantNumber={29}
      archKey="polaroid_wall"
      archLabel="Polaroid Washi Wall"
      palName="FuchsiaGlow"
      grad="from-fuchsia-500 via-pink-500 to-purple-700"
      lightBg="bg-fuchsia-50"
      textCol="text-fuchsia-700"
      borderCol="border-fuchsia-200"
      btnCls="bg-fuchsia-600 hover:bg-fuchsia-700"
      hexCol="#d946ef"
      {...props}
    />
  );
}
